import { render, staticRenderFns } from "./CompetitorsHeaders.vue?vue&type=template&id=23309700&scoped=true"
import script from "./CompetitorsHeaders.vue?vue&type=script&lang=js"
export * from "./CompetitorsHeaders.vue?vue&type=script&lang=js"
import style0 from "./CompetitorsHeaders.vue?vue&type=style&index=0&id=23309700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23309700",
  null
  
)

export default component.exports